import React from 'react';
import { AnimatedSection, SectionHeader, GlowCard } from '@/components/ui';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

const steps = [
  {
    num: '01',
    title: 'Upload your content',
    desc: 'Your chatbot learns everything in your docs, FAQs, and support guides.',
  },
  {
    num: '02',
    title: 'AI trains on it',
    desc: 'The model reads your content and builds a knowledge graph tuned to your business.',
  },
  {
    num: '03',
    title: 'Embed and go live',
    desc: 'Paste one script tag — your chatbot is live on any site in under a minute.',
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-16 md:py-24 bg-muted/30">
    <div className="container">
      <AnimatedSection>
        <SectionHeader
          title="Up and running in three steps"
          description="No developers, no complex setup — just results."
          align="center"
        />
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 max-w-5xl mx-auto mt-12 items-start">
          {steps.map(({ num, title, desc }, index) => (
            <React.Fragment key={num}>
              <GlowCard className="md:col-span-1 p-5 md:p-6">
                <motion.div
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
                >
                  <p className="text-5xl md:text-6xl font-bold font-display text-primary/30 leading-none mb-3">
                    {num}
                  </p>
                  <p className="text-sm font-bold font-display text-foreground mb-2">{title}</p>
                  <p className="text-sm text-muted-foreground leading-relaxed">{desc}</p>
                </motion.div>
              </GlowCard>
              {index < steps.length - 1 && (
                <div className="hidden md:flex items-start justify-center pt-5 md:col-span-1">
                  <ChevronRight className="w-5 h-5 text-primary/30 mt-6" aria-hidden="true" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </AnimatedSection>
    </div>
  </section>
);
